import React from 'react';
import RestaurantIcon from '@material-ui/icons/Restaurant';
const Card = (props) => {
    return (
        <>
            <div className="col-sm-4 left_section" style={{padding:"10px"}}>
                <div className="card Cardiv">
                    <div className="view overlay">
                        <img className="card-img-top" src={props.movieImgSrc} alt="Card image cap" style={{ height: "285px" }} />
                        <a href="#!">
                            <div className="mask rgba-white-slight"></div>
                        </a>
                    </div>
                    <div className="card-body">
                    <h5 className="pink-text pb-2 pt-1" style={{color:"red",fontSize:"20px"}}><i className="fas fa-utensils"></i><RestaurantIcon /> Culinary</h5>
                        <h4 className="card-title">{props.movieCardTitle}</h4>
                        <p className="card-text">{props.movieCardParagraph}</p>
                        <a href="/carddetail" className="btn btn-primary btn-md">{props.btn}</a>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Card;